import { render, staticRenderFns } from "./AuthenticatedLayout.vue?vue&type=template&id=b83dbc6e&scoped=true&"
import script from "./AuthenticatedLayout.vue?vue&type=script&lang=js&"
export * from "./AuthenticatedLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b83dbc6e",
  null
  
)

export default component.exports